// Service
import puppySellService from "@/app/services/main/puppy-sell/puppy-sell-service.js"
import addressFinderAutocompleteService from "@/app/services/address-finder/address-finder-autocomplete/address-finder-autocomplete-service.js"
import userService from "@/app/services/main/user/user-service.js"

// Utils
import { vuelidateUtil } from "@/utils/vuelidate-util.js"

// Mixins
import { inputTextMixins } from "@/app/mixins/utils/input-text-mixins"
import { toastMessageMixins } from "@/app/mixins/utils/toast-message-mixins"
import { userMixins } from "@/app/mixins/modules/user-mixins.js"
import { addressMixins } from "@/app/mixins/utils/address-mixins"
import { dateMixins } from '@/app/mixins/utils/date-mixins';

// Constants
import { STATUS_CODES } from "@/app/constants/status-constants"

// Third Party libraries
const VueGallerySlideshow = () =>
	import(/* webpackPrefetch: true, webpackChunkName: "vue-gallery-slideshow"*/ "vue-gallery-slideshow")
const VueLightboxAdvanced = () =>
	import(/*webpackPrefetch: true, webpackChunkName: "vue-lightbox-advanced"*/ "vue-lightbox-advanced")

export default {
	name: "PuppyForSaleDetails",
	components: {
		VueGallerySlideshow,
		VueLightboxAdvanced,
	},
	mixins: [inputTextMixins, toastMessageMixins, userMixins, addressMixins, dateMixins],
	data() {
		return {
			// Breeder Details
			breederDetails: {
				code: "",
				address: "",
				imageUrl: "",
				mobileNumber: "",
				name: "",
				breederDetails: "",
				email: "",
				verified: null,
			},

			// Puppy Details
			puppyDetails: {
				id: null,
				breedName: "",
				gender: "",
				images: [],
				microchipNumber: "",
				price: "",
				storeCredit: "",
				headline: "",
				body: "",
				totalPrice: "",
				puppySearchCode: "",
				birthdate: "",
			},

			puppyStatus: null,
			// Checkout Details
			inputFields: {
				firstName: "",
				lastName: "",
				email: "",
				address: "",
				mobileNumber: "",
			},

			paymentMethod: "latitudePayCard",
			paymentMethodsLoading: false,
			lpayImage: "",

			// address
			addressList: [],
			isAddressLoading: false,
			selectedPayment: "",
			addressShipping: null,
			isAutoPopulateShipping: false,
			isDefaultAddress: false,

			// Mobile Number
			mobileNumberIsValid: true,

			// Puppy Images
			puppyPrimaryImg: "",
			puppyImages: [],
			otherImages: [],

			// Terms and Conditions
			termsAndConditions: false,
			isAgreed: true,

			index: null,
			isAPILoading: false,
			storeCredit: process.env.VUE_APP_STORE_CREDIT,

			// read more
			puppyDescLimit: 150,
		}
	},

	created() {
		this.getPuppyDetails(this.$route.query.id)
		this.setUserDetails()
	},

	mounted() {
		window.scrollTo( 0, 0 )
	},

	computed: {
		validationRules() {
			let fields = {
				inputFields: {
					firstName: {},
					lastName: {},
					email: {},
					address: {},
					mobileNumber: {},
				},
			}

			fields.inputFields = vuelidateUtil.setFieldsRequired(fields.inputFields, true)
			fields.inputFields = vuelidateUtil.setEmailValidation(fields.inputFields, "email")

			return fields
		},

		puppyButtonText() {
			return this.puppyStatus === true ? "Apply" : "Puppy Unavailable"
		},

		isDisabled() {
			return this.isAPILoading || this.puppyStatus === false
		},
	},

	watch: {
		termsAndConditions() {
			if (this.termsAndConditions === false) {
				this.isAgreed = false
				return
			}
			this.isAgreed = true
		},
	},
	methods: {
		// Retrieve Puppy Details
		async getPuppyDetails(puppySellId) {
			if (!puppySellId) return

			try {
				this.isAPILoading = true

				const response = await puppySellService.getPuppySellDetailsById({
					f_puppyToSellId: puppySellId,
				})

				if (response.status === STATUS_CODES.SUCCESS) {
					this.setFieldsData(response.data)

					this.isAPILoading = false

					this.showLatitudeCard()
				} else {
					this.isAPILoading = false
				}
			} catch (err) {
				// Catch any error
				this.isAPILoading = false
			}
		},

		setFieldsData(data) {
			let notPrimaryImg
			const { address, imageUrl, mobileNumber, name, code, email, companyName } = data.breeder
			const {
				id,
				breedName,
				gender,
				images,
				microchipNumber,
				price,
				storeCredit,
				headline,
				body,
				status,
				totalPrice,
				puppyReferenceNumber,
				birthdate,
			} = data.puppyDetails

			this.breederDetails = {
				address,
				imageUrl,
				mobileNumber,
				name,
				email,
				code,
				companyName,
			}

			this.puppyDetails = {
				id,
				breedName,
				gender,
				images,
				microchipNumber,
				price,
				storeCredit,
				headline,
				body,
				totalPrice,
				puppySearchCode: puppyReferenceNumber,
				birthdate: this.formatDate(birthdate),
			}

			this.puppyStatus = status !== "PP" ? true : false

			this.puppyPrimaryImg = this.puppyDetails.images.filter((image) => {
				return image.primary === true
			})

			this.puppyImages = this.puppyDetails.images.map((image) => {
				return image.imageUrl
			})

			notPrimaryImg = this.puppyDetails.images.filter((image) => {
				return image.primary === false
			})

			this.otherImages = notPrimaryImg.map((image) => {
				return image.imageUrl
			})
		},
		showLatitudeCard() {
			window.LatitudeCheckout = {
				merchantId: process.env.VUE_APP_MERCHANT_ID,
				page: "product",
				container: "latitude-banner-container",
				containerClass: "",
				currency: "AUD",
				minAmount: "",
				layout: "inversed",
				paymentOption: "equal",
				promotionMonths: "24",
				product: {
					id: this.puppyDetails.id,
					name: `${this.puppyDetails.breedName} and product shop credit`,
					category: "Puppy Purchase",
					price: this.puppyDetails.totalPrice,
					sku: this.puppyDetails.id,
				},
			}

			this.createLatitudeScript()
		},
		createLatitudeScript() {
			const script = document.createElement("script")
			script.src = `${process.env.VUE_APP_MERCHANT_URL}${process.env.VUE_APP_MERCHANT_ID}`
			document.body.appendChild(script)
		},
		// Retrieve User if Logged In
		async setUserDetails() {
			let shipping;
			const { firstName, lastName, emailAddress, id, ...res } = this.getUserDetails()

			if (id) {
				await userService.getUserAddress().then(async (res) => {
					if (res.status === 200) {
						const { shippingAddress, userAddress } = res.data.addressDetails

						// use the shipping address from the checkout page if there is, otherwise use address from the user profile page
						shipping = Object.keys(shippingAddress).length ? shippingAddress : userAddress;
					}
				})
			}

			this.inputFields.firstName = firstName
			this.inputFields.lastName = lastName
			this.inputFields.email = emailAddress

			if (shipping && Object.keys(shipping).length > 0) {

				// fallback approach for old data without addressLine1 and cityTown required by latitude
				if(shipping.referenceId && (!shipping.addressLine1 || !shipping.cityTown)){
					const metadata = await this.getAddressMetaData({id: shipping.referenceId});
					shipping.addressLine1 = metadata.address_line_1;
					shipping.cityTown = metadata.lga_name;
				}

				this.inputFields.mobileNumber = shipping.mobileNumber.replace(/(....)(......)/g, "$1-$2")
				this.inputFields.address = shipping.address
				this.addressShipping = shipping
			}

			this.isAutoPopulateShipping = true
		},

		// Address
		findAddress(address, type) {
			if (address) {
				if (type === "shipping") {
					this.isAddressLoading = true
				} 

				this.delayTyping(() => {
					this.getAutocompleteAddress(address)
				})
			}
		},
		getAutocompleteAddress(address) {
			addressFinderAutocompleteService
				.getAutocompleteAddress(address)
				.then((res) => {
					if (res.status === STATUS_CODES.SUCCESS) {
						this.addressList = res.data.completions
						this.isAddressLoading = false
					} else {
						const { ERROR_GET_ADDRESS } = this.toastMessages.addressFinder()
						this.showAPIErrorToast(ERROR_GET_ADDRESS, res)
						this.isAddressLoading = false
					}
				})
				.catch(() => {
					this.showGenericErrorToast()
					this.isAddressLoading = false
				})
		},
		async onBlur(field, type) {
			let address

			this.$v.inputFields[field].$touch()
			if (field === "address") {
				if (this.isAutoPopulateShipping) return
			} 

			if (this.inputFields[field] && this.inputFields[field] != "") {
				address = await this.getAddressMetaData(this.inputFields[field])
				this.processAddress(type, address)
			}
		},

		async getAddressMetaData(address) {
			return addressFinderAutocompleteService
				.getAddressMetaData(address.id)
				.then((res) => {
					if (res.status === STATUS_CODES.SUCCESS) {
						return res.data
					} else {
						const { ERROR_GET_ADDRESS } = this.toastMessages.addressFinder()
						this.showAPIErrorToast(ERROR_GET_ADDRESS, res)
						this.isAddressLoading = false
					}
				})
				.catch(() => {
					this.showGenericErrorToast()
					this.isAddressLoading = false
				})
		},
		processAddress(type, address) {
			const updatedAddress = {
				address: address.full_address,
				referenceId: address.id,
				addressLine1: address.address_line_1,
				addressLine2: address.address_line_2,
				suburb: address.locality_name,
				cityTown: address.lga_name,
				state: address.state_territory,
				postcode: address.postcode,
				country: "Australia",
			}
			if (type === "shipping") {
				this.addressShipping = {
					...updatedAddress,
					addressType: "SHIPPING",
				}
			} 
		},
		selectedAddress(type) {
			if (type === "shipping") {
				this.isAutoPopulateShipping = false
				return
			}
		},

		async postUserAddress() {
			const { firstName, lastName } = this.userDetails
			let address = []

			let shipAddress = this.addressShipping

			shipAddress.firstName = firstName
			shipAddress.lastName = lastName
			shipAddress.mobileNumber = this.inputFields.mobileNumber.replace("-", "")
			shipAddress.isDefault = 1
			shipAddress.addressType = "SHIPPING"

			address = [shipAddress]
			await userService.postUserAddress({ address })
		},

		// Mobile Number
		formMobileNumberFormat(event) {
			this.mobileNumberIsValid = true
			this.inputFields.mobileNumber = this.formatMobileNumberOnChange(event);
		},

		breederMobileNumberFormat(mobileNumber) {
			if (mobileNumber) {
				let data = mobileNumber.split("")
				data.splice(4, 0, "-")
				return data.join("")
			} else {
				return ""
			}
		},
		onPasteMobileNumber(event) {
			event.preventDefault(); // Prevent default paste behavior
			const pastedText = event.clipboardData.getData('text/plain');

			const formatMobileNumberOnPaste = this.formatMobileNumberOnPaste(pastedText)
			event.target.value = formatMobileNumberOnPaste;
		},
		checkFormat() {
			this.$v.inputFields.mobileNumber.$touch()

			let regexp = /^\d{4}-\d{6}$/

			if (this.inputFields.mobileNumber !== null && this.inputFields.mobileNumber !== "") {
				this.mobileNumberIsValid = regexp.test(this.inputFields.mobileNumber)
			} else {
				this.mobileNumberIsValid = true
			}
		},

		calculatedPrice(price) {
			return parseInt(price / 24)
		},
		calculatedPriceWithDecimal(price) {
			if(!price) return;
			return parseFloat(price / 24).toFixed(2)
		},

		// Gallery
		onClicked(v) {
			this.index = v
		},

		// Checkout
		async onCheckout() {
			this.$v.$touch()

			if (!this.termsAndConditions) {
				this.showCustomErrorToast(null, "You must agree to the Privacy and Consumer Policy to proceed.")
				this.isAgreed = false
				return
			}

			if (this.$v.$invalid || !this.mobileNumberIsValid || this.puppyStatus === false) {
				return
			}

			try {
				this.isAPILoading = true

				const address = {
					address: this.addressShipping.address || "N/A", 
					addressLine1: this.addressShipping.addressLine1 || "N/A",
					addressLine2: this.addressShipping.addressLine2 || "N/A",
					suburb: this.addressShipping.suburb || "N/A",
					cityTown: this.addressShipping.cityTown || "N/A",
					state: this.addressShipping.state || "N/A",
					postcode: this.addressShipping.postcode || "N/A",
					countryCode: "AU",
				}

				const paymentDetails = {
					customer: {
						mobileNumber: this.inputFields.mobileNumber.replace("-", ""),
						firstName: this.inputFields.firstName,
						surname: this.inputFields.lastName,
						email: this.inputFields.email,
					},
					shippingAddress: address,
					billingAddress: address,
					puppyToSellId: this.puppyDetails.id,
					paymentMethod: this.paymentMethod,
				}


				const response = await puppySellService.puppyCheckoutWithLpCard(paymentDetails)

				if (response.status === STATUS_CODES.SUCCESS) {
					let url
					const { redirectUrl } = response.data
					url = redirectUrl

					this.redirectToLP(url)

					this.isAPILoading = false
				} else {
					this.showAPIErrorToast("Unable to Process Checkout.", response)
					this.isAPILoading = false
				}
			} catch (error) {
				this.showGenericErrorToast()
				this.isAPILoading = false
			}
		},

		redirectToLP(url) {
			const latitudeInterestFreeImg = require("@/assets/images/_shared/latitude-interest-free-logo.svg")
			this.$swal({
				title: "Redirecting to ...",
				html: `<img style='width: 300px' src=${latitudeInterestFreeImg}>`,
				allowOutsideClick: false,
				timer: 2000,
				showCancelButton: false,
				showConfirmButton: false,
			}).then(() => {
				window.location = url
			})
		},

		showEmail(email) {
			if (email) {
				window.location.href = `mailto:${email}`
			}
		},
		readMoreAndModal() {
			const puppyPrimaryImage = this.puppyDetails.images && this.puppyDetails.images.length > 0 ? this.puppyDetails.images[0].imageUrl : require('@/assets/images/_shared/dog-smile.svg');

			this.$swal({
				imageUrl: puppyPrimaryImage,
				imageHeight: "200px",
				html: this.puppyDetails.body || "",
				confirmButtonText: "Close",
				showConfirmButton: true,
				showCancelButton: false,
			})
		},
	},
	validations() {
		return this.validationRules
	},
}
